import React, { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { SheetReviewProvider } from './components/SheetReviewContext'
import SheetReviewBanner from './components/SheetReviewBanner'
import './CharacterDetail.css'

export default function CharacterDetailLayout({ funcNav = () => {}, funcCharNavbar = () => {} }) {
  const { slug } = useParams()

  useEffect(() => {
    if (typeof funcNav === 'function') funcNav(false)
    if (typeof funcCharNavbar === 'function') funcCharNavbar(true)
  }, [funcNav, funcCharNavbar])

  return (
    <div className="char-detail char-wrapper-like-inventory">
      <div className="char-detail__content">
        <SheetReviewProvider slug={slug}>
          <SheetReviewBanner />
          <Outlet />
        </SheetReviewProvider>
      </div>
    </div>
  )
}
